module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"jquery","commonjs2":"jquery","amd":"jquery","root":"jQuery"}
// module id = 0
// module chunks = 0 1